import React from 'react';
import { Modal, Select, Input, message } from 'antd';
import { SwapOutlined } from '@ant-design/icons';

const { TextArea } = Input;

const REASON_OPTIONS = [
  { value: 'cancel_same_day', label: 'Cancel Same Day' },
  { value: 'make_up', label: 'Make Up' },
];

const CustomModal = ({ isOpen, onClose, onSubmit, reason, setReason, note, setNote }) => {

  const handleSubmit = () => {
    onSubmit(reason, note);
    setReason('');
    setNote('');
    message.success('Updated successfully');
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      onOk={handleSubmit}
      okText="Submit"
      cancelText="Cancel"
      title={
        <span>
          <SwapOutlined style={{ marginRight: 8, color: '#1890ff' }} />
          Reason for Change
        </span>
      }
      width={480}
      centered
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginTop: 16 }}>
        <div>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, fontSize: 13, color: '#555' }}>
            Reason
          </label>
          <Select
            value={reason || undefined}
            onChange={setReason}
            placeholder="Select a reason"
            style={{ width: '100%' }}
            options={REASON_OPTIONS}
          />
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, fontSize: 13, color: '#555' }}>
            Note
          </label>
          <TextArea
            placeholder="Add a note (optional)"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows={3}
            style={{ resize: 'none' }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CustomModal;
